/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Text, FontIcon, Stack } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './VerticalSteps.style';
import ReconResults from '../ReconResults';

const VerticalSteps = ({ steps, reconResults }) =>
  steps.map((step, index) => {
    let icon;
    let lineItemText = (
      <Text as="p" style={{ fontWeight: 'normal' }}>
        {step.content}
      </Text>
    );

    switch (step.status) {
      case 'Closed':
        icon = (
          <FontIcon
            iconName="SkypeCircleCheck"
            arianame="SkypeCircleCheck"
            className={styles.iconCompleted}
          />
        );
        break;
      case 'Open':
        icon = (
          <FontIcon iconName="CircleRing" arianame="CircleRing" className={styles.iconInprogress} />
        );
        lineItemText = (
          <Text as="p" variant="medium">
            {step.content}
          </Text>
        );
        break;
      case 'Future':
        icon = (
          <FontIcon
            iconName="CircleShapeSolid"
            arianame="CircleShapeSolid"
            className={styles.iconFuture}
          />
        );
        lineItemText = (
          <Text
            as="p"
            style={{ fontWeight: 'normal', color: '#696565' }}
            className={styles.iconFuture}
          >
            {step.content}
          </Text>
        );
        break;
      case 'Rejected':
        icon = (
          <FontIcon
            iconName="StatusErrorFull"
            arianame="StatusErrorFull"
            className={styles.iconRejected}
          />
        );
        lineItemText = (
          <Text as="p" variant="medium">
            {step.content}
          </Text>
        );
        break;
      case 'Skipped':
        icon = (
          <FontIcon iconName="InfoSolid" arianame="InfoSolid" className={styles.iconSkipped} />
        );
        break;
      case 'Regenerated':
        icon = (
          <FontIcon
            iconName="SyncStatusSolid"
            arianame="SyncStatusSolid"
            className={styles.iconRegenerated}
          />
        );
        lineItemText = (
          <Text as="p" variant="medium">
            {step.content}
          </Text>
        );
        break;
      default:
        icon = <FontIcon iconName="StatusCircleQuestionMark" arianame="StatusCircleQuestionMark" />;
    }

    const nextStep = steps[index + 1];
    let verticalBarColorClass;

    switch (nextStep && nextStep.status) {
      case 'Closed':
        verticalBarColorClass = styles.verticalBarCompleted;
        break;
      case 'Open':
        verticalBarColorClass = styles.verticalBarInProgress;
        break;
      case 'Future':
        verticalBarColorClass = styles.verticalBarFuture;
        break;
      case 'Rejected':
        verticalBarColorClass = null;
        break;
      case 'Regenerated':
        verticalBarColorClass = null;
        break;
      default:
        verticalBarColorClass = styles.verticalBarCompleted;
        break;
    }

    return (
      <div
        key={index}
        className={
          step.status === 'Rejected' || step.status === 'Regenerated'
            ? styles.interruption
            : styles.container
        }
      >
        <div className={styles.itemIcons}>
          <div className={styles.icon}>{icon}</div>
          {index < steps.length - 1 && (
            <div className={styles.verticalBarContainer}>
              {step.status !== 'Rejected' && step.status !== 'Regenerated' && (
                <div className={clsx(styles.verticalBar, verticalBarColorClass)} />
              )}
            </div>
          )}
        </div>
        <div className={styles.itemContentContainer}>
          <div className={styles.firstRow}>
            <div className={styles.itemContent}>{lineItemText}</div>
            <div className={styles.itemDate}>
              {step.date && (
                <Text className={styles.itemDateFont}>
                  {moment.tz(step.date, 'America/Los_Angeles').format('MMM DD, YYYY HH:mmA z')}
                </Text>
              )}
            </div>
          </div>
          <div className={styles.secondRow}>
            {index === 0 &&
              reconResults.map(reconResult => {
                return <ReconResults name={reconResult.name} status={reconResult.status} />;
              })}
            {step.additionalContent && (
              <Stack horizontal disableShrink wrap tokens={{ childrenGap: 10 }}>
                <Stack.Item>
                  <FontIcon iconName="Comment" arianame="Comment" />
                </Stack.Item>
                <Stack.Item>
                  <Text block variant="small">
                    {step.additionalContent}
                  </Text>
                </Stack.Item>
              </Stack>
            )}
          </div>
          <div
            className={
              step.status === 'Rejected' || step.status === 'Regenerated'
                ? styles.bottomBorderInterruption
                : styles.bottomBorder
            }
          />
        </div>
      </div>
    );
  });

VerticalSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default VerticalSteps;
